export const INDUSTRIES = [
  "商社・問屋",
  "ガス事業者",
  "ガス事業者サービス店",
  "キッチンメーカー",
  "リフォーム・リノベーション",
  "工務店・ビルダー",
  "設計事務所",
  "マンション管理",
  "訪問販売",
  "インターネット販売",
  "サブコン・設備",
  "デベロッパー",
  "ゼネコン",
  "ハウスメーカー",
  "その他（マスコミ等）",
];
